import LocationList from "@/views/master/location/LocationList";
import LocationEdit from "@/views/master/location/LocationEdit";
import LocationReportAsyn from "@/views/master/location/LocationReportAsyn";
import LocationReportSyn from "@/views/master/location/LocationReportSyn";

import EquipmentList from "@/views/master/equipment/EquipmentList";
import EquipmentEdit from "@/views/master/equipment/EquipmentEdit";

import ManageReportGeneratedList from "@/views/master/report/ManageReportGeneratedList";
import ReportList from "@/views/master/report/ReportList";
import ReportEdit from "@/views/master/report/ReportEdit";

import MaterialList from "@/views/master/material/MaterialList";
import MaterialEdit from "@/views/master/material/MaterialEdit";

import EnergyList from "@/views/master/energy/EnergyList"; 
import EnergyEdit from "@/views/master/energy/EnergyEdit";

import ShiftList from '@/views/master/shift/ShiftList.vue';
import ShiftEdit from '@/views/master/shift/ShiftEdit.vue';

import ProcessOptionList from "@/views/master/processConf/ProcessOptionList";
import ProcessOptionEdit from "@/views/master/processConf/ProcessOptionEdit";

import ProcessMaterialList from "@/views/master/processConf/ProcessMaterialList";
import ProcessMaterialEdit from "@/views/master/processConf/ProcessMaterialEdit";

import ProcessEnergyList from "@/views/master/processConf/ProcessEnergyList";
import ProcessEnergyEdit from "@/views/master/processConf/ProcessEnergyEdit";
import LocationTreeList from "@/views/master/location/LocationTreeList";

// import MesEditPage from '@/components/MesEditPage'

import Home from "@/views/master/Home";

const metaObject = { requiresAuth: true, roles: ['mmf'] };

export default [{
        path: "/master",
        name: "home-master",
        component: Home,
        meta: metaObject
    },
    {
        path: "/master/location",
        name: "locationList",
        component: LocationList,
        meta: metaObject
    },
    {
        path: "/master/location/edit",
        name: "locationEdit",
        component: LocationEdit,
        meta: metaObject
    },
    {
        path: "/master/location/report/synchronous",
        name: "locationReportSyn",
        component: LocationReportSyn,
        meta: metaObject
    },
    {
        path: "/master/location/report/asynchronous",
        name: "locationReportAsyn",
        component: LocationReportAsyn,
        meta: metaObject
    },
    {
        path: "/master/equipment",
        name: "equipmentList",
        component: EquipmentList,
        meta: metaObject
    },
    {
        path: "/master/equipment/Edit",
        name: "equipmentEdit",
        component: EquipmentEdit,
        meta: metaObject
    },
    {
        path: "/master/report/manage",
        name: "ManageReportGeneratedList",
        component: ManageReportGeneratedList,
        meta: metaObject
    },
    {
        path: "/master/report",
        name: "reportList",
        component: ReportList,
        meta: metaObject
    },
    {
        path: "/master/report/edit",
        name: "reportEdit",
        component: ReportEdit,
        meta: metaObject
    },
    {
        path: "/master/material",
        name: "materialList",
        component: MaterialList,
        meta: metaObject
    },
    {
        path: "/master/material/edit",
        name: "materialEdit",
        component: MaterialEdit,
        meta: metaObject
    },
    {
        path: "/master/energy",
        name: "energyList",
        component: EnergyList,
        meta: metaObject
    },
    {
        path: "/master/energy/edit",
        name: "energyEdit",
        component: EnergyEdit,
        meta: metaObject 
    },
    {
        path: "/master/teamShift/edit",
        name: "teamShiftEdit",
        component: ShiftEdit,
    },
    {
        path: "/master/teamShift",
        name: "teamShiftList",
        component: ShiftList,
    }, 

    {
        path: "/master/processOption",
        name: "processOptionList",
        component: ProcessOptionList,
        meta: metaObject 
    },
    {
        path: "/master/processOption/edit",
        name: "processOptionEdit",
        component: ProcessOptionEdit,
        meta: metaObject 
    },
    {
        path: "/master/processMaterial",
        name: "processMaterialList",
        component: ProcessMaterialList,
        meta: metaObject 
    },
    {
        path: "/master/processMaterial/edit",
        name: "processMaterialEdit",
        component: ProcessMaterialEdit,
        meta: metaObject 
    },
    {
        path: "/master/processEnergy",
        name: "processEnergyList",
        component: ProcessEnergyList,
        meta: metaObject 
    },
    {
        path: "/master/processEnergy/edit",
        name: "processEnergyEdit",
        component: ProcessEnergyEdit,
        meta: metaObject 
    },
    {
        path: "/master/location/tree",
        name: "locationTreeList",
        component: LocationTreeList
    },
]